import React from "react";
import G from "../libs/Glob.mjs";
import {Button, ButtonGroup } from "reactstrap";
import ExitIcon from "../media/images/ExitIcon.mjs";
import TextLabel from "./TextLabel.mjs";

/**
 * @typedef ButtonExiProps
 * @type {object}
 * @property {function|boolean} [exit] Triggered to exit (if function), works as "back" if true
 * @property {string|JSX.Element|false} [exitLabel]
 * @property {GlobPage|string} [exitPage] The optional "back" page
 * @property {string} [exitTitle]
 */

/**
 * Detached buttonbar for Exit
 * @desc In parameters specify event key to be triggered for Exit.
 * @summary The component represents a detached control, it can be placed in a different location/hierarchy (optionally by Glob.trigger()'ing it).
 * @summary In case a function isn't passed the related button won't show.
 * @param {ButtonExiProps} props
 * @param {function|boolean} [props.exit] Triggered to exit (if function), works as "back" if true
 * @param {string|JSX.Element|false} [props.exitLabel]
 * @param {string} [props.exitTitle]
 * @see Glob.trigger
 * @return {JSX.Element}
 */
const ButtonExit = class extends React.Component {
	/**
	 * @constructor
	 * @param {ButtonExiProps} props
	 */
	constructor(props) {
		super(props);
		this.uid = G.generateUid('ButtonExit');
	}
	render() {
		return(
			<div
				className={"ButtonExit"}
				id={this.uid}
			>
				<ButtonGroup className={"btn-icon"}>
					<Button
						disabled={ ! this.props.exit }
						color={"warning"}
						title={ this.props.exitTitle ?? G.label('Exit') }
						onClick={ ()=>{
							if ( typeof this.props.exit === 'function') {
								this.props.exit();
								return;
							}
							const pg = this.props.exitPage || G.getStatus('previousPage') || G.getHomePage();
							G.gotoPage( pg );
						}}
					>
						<i>
							<ExitIcon />
						</i>
						{ this.props.exitLabel === false ? '' : (
							<b>
								{this.props.exitLabel ?? <TextLabel value={"Exit"} />}
							</b>
						)}
					</Button>
				</ButtonGroup>
			</div>
		)
	}
}

export default ButtonExit;
